import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from '../atoms/boxes';
export const PageWrapper = ({ children, ...props }) => {
    return (_jsx(Column, { flex: 1, justifyContent: "flex-start", ...props, children: children }));
};
